import { MeasurementName } from '@quromedical/models';

import { type Configuration, getValue, type Resolver } from './internal';
import { interpret } from './interpreter';

export type BloodPressureParams = {};

/**
 * from https://www.ncbi.nlm.nih.gov/books/NBK538226
 *
 * MAP = DP + 1/3(SP – DP)
 */
const getMeanArterialPressure = (
  systolicBloodPressure: number,
  diastolicBloodPressure: number,
) =>
  diastolicBloodPressure +
  (1 / 3) * (systolicBloodPressure - diastolicBloodPressure);

const resolveMeanArterialPressure: Resolver<BloodPressureParams> = (
  relative,
  windowVitals,
) => {
  const systolic = getValue(
    windowVitals[MeasurementName.SystolicArterialBloodPressure],
  );
  const diastolic = getValue(
    windowVitals[MeasurementName.DiastolicArterialBloodPressure],
  );

  const hasUndefined = systolic === undefined || diastolic === undefined;
  if (hasUndefined) {
    return [];
  }

  const meanArterialPressure = getMeanArterialPressure(systolic, diastolic);
  return [
    {
      ts: relative,
      type: MeasurementName.MeanArterialBloodPressure,
      value: meanArterialPressure.toString(),
    },
  ];
};

const meanArterialPressureConfig: Configuration<BloodPressureParams> = {
  window: 10000,
  base: MeasurementName.DiastolicArterialBloodPressure,
  resolve: resolveMeanArterialPressure,
};

export const configurations = [meanArterialPressureConfig];
export const calculateBloodPressure = interpret(configurations);
